<mat-toolbar style="background-color:#d1d8e0;">
  <img [src]="src" style="width: 56px;height: 56px;" class="d-inline-block align-top" alt="" loading="lazy">
  <span style="  font-family: Roboto;font-size: 20px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: -0.11px;text-align: center;color: #4a4a4a;">Jetico Messenger <span style="font-size: 8px;">1.0</span></span>
</mat-toolbar>
